module.exports = __webpack_public_path__ + "img/png-icon.c6931d8a.svg";